import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import "./VisaApplicationChoice.scss";
import FormButtons from "./FormButtons";
import ProgramTitleContainer from "./ProgramTitleContainer";

class VisaApplicationChoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      modalOpen: false,
    };
  }

  render() {
    let {
      name,
      description,
      link,
      forms,
      toggleReuse,
      toggleDetermineVersionModal,
      setReuseParameters,
      multiVersion,
      setIsReusable,
    } = this.props;

    return (
      <div className="usa-application-box">
        <ProgramTitleContainer>
          <p className="application-type"></p>
          <h1 className="application-title">{name}</h1>
          <p className="visa-description">{description}</p>
          <small>
            <a href={link} target="_blank">
              <span className="usa-link">Learn more</span>{" "}
              <span
                className="usa-link"
                style={{ padding: "5px 0 0 5px", display: "inline-block" }}
              >
                <FaExternalLinkAlt />
              </span>
            </a>
          </small>
        </ProgramTitleContainer>
        <FormButtons
          forms={forms}
          toggleReuse={toggleReuse}
          toggleDetermineVersionModal={toggleDetermineVersionModal}
          setReuseParameters={setReuseParameters}
          multiVersion={multiVersion}
          setIsReusable={setIsReusable}
        />
      </div>
    );
  }
}

export default VisaApplicationChoice;
